<template>
  <div
    ref="chatBotModal"
    aria-hidden="true"
    aria-labelledby="chatBotModal"
    class="modal fade"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content" v-if="message && message.content && message.writer">
        <div class="modal-header">
          <h5 class="modal-title textStyle">
            {{ message.writer === "me" ? user.firstName : "Léa" }}
          </h5>
          <button
            aria-label="Close"
            class="btn-close"
            data-bs-dismiss="modal"
            data-dismiss="modal"
            type="button"
          ></button>
        </div>
        <div class="modal-body">
          <div class="chatbot__text" v-html="message.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import { mapState } from "pinia";
import { useUserStore } from "@/store/user/user";

export default {
  name: "ChatBotModalComponent",
  props: {
    message: {
      type: Object,
      required: false,
      default: () => null,
    },
    opened: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  emits: ["hidden"],
  watch: {
    opened() {
      const container = this.$refs.chatBotModal;
      const modal = new Modal(container);
      if (this.opened) {
        modal.show();
      } else {
        modal.hide();
        this.$emit("hidden");
      }
    },
  },
  computed: {
    ...mapState(useUserStore, {
      user: (store) => store.user,
    }),
  },
  mounted() {
    this.$refs.chatBotModal.addEventListener("hidden.bs.modal", this.hidden);
  },
  methods: {
    hidden() {
      this.$emit("hidden");
      const container = this.$refs.chatBotModal;
      container.removeEventListener("click", this.stop);
    },

    stop(e) {
      e.stopPropagation();
    },
  },
};
</script>

<style scoped lang="scss">
.indicator__container {
  padding: 10px 10px 0 10px;
  font-size: 15px;
}

.modal {
  z-index: 1061;
}
</style>
